require('./jv.login.service.js');

angular.module('jv.reset.password.controller', [
    'ngStorage',
    'jv.login.service'
])
.controller('jvResetPasswordController', [
    '$scope', '$window','$timeout','jvLoginService','$localStorage',
    function($scope, $window, $timeout, jvLoginService, $localStorage) {

        //initialize properties
        $scope.properties = window.properties;
        //page data
        $scope.pageData = window.pageData;

        $scope.loginUrl =  '/login/login.html';

        $scope.data = {
            initialized: false,
            resetPasswordForm:{
                $submitted: false
            },
            passwordPolicy: {
                numberPolicy: '.*[0-9].*',               //should contain at least one digit
                lowercasePolicy:'.*[a-z].*',             //should contain at least one lower case
                uppercasePolicy:'.*[A-Z].*',             //should contain at least one upper case
                characterPolicy: function(str){          //should contain at least 8 from the mentioned characters
                    return (str && str.length >=8);
                },
                matchPolicy: function(str1, str2){
                    return (str1 === str2);
                }
            },
            password: {
                matchPolicy: false,
                numberPolicy: false,
                lowercasePolicy: false,
                uppercasePolicy: false,
                characterPolicy: false
            }
        };

        $scope.data.token = $window.location.search.split('?token=')[1];
        $timeout(function(){
            $scope.data.initialized = true;
        },300);

        var validatePasswordPolicy = function(passwordStr,policy){
            if(typeof $scope.data.passwordPolicy[policy] === 'function' ){
                $scope.data.password[policy] = $scope.data.passwordPolicy[policy]($scope.data.newPassword, $scope.data.confirmPassword);
            }else{
                var regEx = new RegExp($scope.data.passwordPolicy[policy]);
                var isValid = regEx.test(passwordStr);
                $scope.data.password[policy] = isValid ? true: false;
            }
        };

        $scope.$watch('data.newPassword',function(newVal,oldVal){
            if(newVal || oldVal){
                $timeout(function(){
                    validatePasswordPolicy(newVal,'characterPolicy');
                    validatePasswordPolicy(newVal,'numberPolicy');
                    validatePasswordPolicy(newVal,'lowercasePolicy');
                    validatePasswordPolicy(newVal,'uppercasePolicy');
                    validatePasswordPolicy(newVal,'matchPolicy');
                },500);
            }
        });

        $scope.$watch('data.confirmPassword',function(newVal,oldVal){
            if(newVal || oldVal){
                $timeout(function(){
                     validatePasswordPolicy(newVal,'matchPolicy');
                },500);
            }
        });

        var validateForm = function(){
            var  isFormValid = true;
            if(!$scope.data.newPassword || !$scope.data.confirmPassword){
                isFormValid = false;
            }
            return isFormValid;
        };

        $scope.goToLoginPage = function(){
            $localStorage.showForgotPasswordModal = true;
            $window.location.href = $scope.loginUrl;
        };

        $scope.resetPassword = function(){
            $scope.data.resetPasswordForm.$submitted = true;
            var isFormValid = validateForm();
            if(isFormValid){
                //ajax post
                var postData = {
                    password: $scope.data.newPassword,
                    confirmPassword: $scope.data.confirmPassword,
                    token: $scope.data.token
                };
                jvLoginService.resetPassword(postData,function(response){
                    $scope.data.resetPasswordForm.$submitted = false;
                    if(response && response.data.success){
                        //if reset password success redirect to login page.
                        $window.location.href = $scope.loginUrl;
                    }else if(response.data.errorMessage){
                        $scope.data.resetPasswordForm.errorMsg = response.data.errorMessage;
                    }
                });
            }else{
                return false;
            }
        };
    }
]);